import React, { Component } from 'react'
import ImageBoxWrapper from './ImageBoxWrapper'
import FirstBox from './StyledFirstBox'
import SmallBox from './StyledSmallBox'
import ContainerRow from './StyledContainerRow'
import LeftColumn from './StyledLeftColumn'
import RightColumn from './StyledRightColumn'
import { sendArticleClick } from '../../utils/ga4Events'
import styled from 'styled-components'

const Separator = styled.div`
  background: #fff;
  bottom: 0;
  display: flex;
  height: 5px;
  justify-content: flex-end;
`

const Line = styled.div`
  border-top: 1px solid #d1d1d1;
  height: 1px;
  position: relative;
  width: 100%;
`

export default class Dynamiclead extends Component {
  render () {
    const {
      widget: {
        boxes,
        name,
        imageSize,
        utmContent,
        utmMedium,
        utmSource
      },
      activeDynamicLayout,
      itemVariant,
      utmCampaign
    } = this.props

    const isAbTestVariant = boxes.length === 7

    if (!boxes || !boxes.length) return null

    const smallBoxes = [...boxes]
    const firstBox = Object.assign({}, smallBoxes.shift(), {
      featuredSize: 'big'
    })

    const utmParams = {
      utmContent,
      utmMedium,
      utmSource,
      utmCampaign
    }

    const handleClick = ({ box, position }) => () =>
      sendArticleClick({
        position,
        boxName: name,
        url: box.link,
        id: box.guid,
        title: box.title,
        variant: itemVariant
      })

    const renderSmallImageBox = (box, index) =>
      <ImageBoxWrapper
        box={box}
        imageBoxComponent={SmallBox}
        imageBoxComponentProps={{ handleAnchorClick: handleClick({ box, position: index + 2 }) }}
        imageSize={imageSize}
        index={index + 1}
        key={`dynamicLeadBox${index + 1}`}
        utmParams={utmParams}
        layout={activeDynamicLayout}
        isAbTestVariant={isAbTestVariant}
      />

    return (
      <ContainerRow id={name} isAbTestVariant={isAbTestVariant}>
        <LeftColumn isAbTestVariant={isAbTestVariant}>
          <ImageBoxWrapper
            box={firstBox}
            imageBoxComponent={FirstBox}
            imageBoxComponentProps={{ handleAnchorClick: handleClick({ box: firstBox, position: 1 }) }}
            imageSize='1_1L'
            index={0}
            utmParams={utmParams}
            layout={activeDynamicLayout}
            isAbTestVariant={isAbTestVariant}
          />
          {
            isAbTestVariant && smallBoxes.map(renderSmallImageBox)
          }
        </LeftColumn>
        {
          !isAbTestVariant && <RightColumn>
            {
              smallBoxes.map(renderSmallImageBox)
            }
          </RightColumn>
        }
        {
          isAbTestVariant && <Separator>
            <Line/>
          </Separator>
        }
      </ContainerRow>
    )
  }
}
